import { useCallback } from "react"
import { Dayjs } from "utils/dayjs"

interface IUseDepartureArrivalDateRulesProps {
    dates: { departureDate: Dayjs | null, arrivalDate: Dayjs | null } | null
    setDates: (dates: { departureDate: Dayjs | null, arrivalDate: Dayjs | null }) => void
    timeOffset?: number
}

export const DEPARTURE_ARRIVAL_DATE_RULES_DEFAULT_TIME_OFFSET = 15

export default function useDepartureArrivalDateRules({
    dates,
    setDates,
    timeOffset = DEPARTURE_ARRIVAL_DATE_RULES_DEFAULT_TIME_OFFSET
}: IUseDepartureArrivalDateRulesProps) {

    const handleDepartureDateChange = useCallback((date: Dayjs | null) => {
        const newDepartureDate = date?.clone() || null
        let newArrivalDate = dates?.arrivalDate?.clone() || null
        if (date && dates?.arrivalDate && (date.diff(dates.arrivalDate, "minute") > -timeOffset)) {
            newArrivalDate = date.clone().add(timeOffset, "minute")
        }
        const newDates = {
            departureDate: newDepartureDate,
            arrivalDate: newArrivalDate
        }
        setDates(newDates)
        return newDates
    }, [dates?.arrivalDate, setDates, timeOffset])

    const handleArrivalDateChange = useCallback((date: Dayjs | null) => {
        const newArrivalDate = date?.clone() || null
        let newDepartureDate = dates?.departureDate?.clone() || null
        if (date && dates?.departureDate && (date.diff(dates.departureDate, "minute") < timeOffset)) {
            newDepartureDate = date.clone().subtract(timeOffset, "minute")
        }
        const newDates = {
            departureDate: newDepartureDate,
            arrivalDate: newArrivalDate
        }
        setDates(newDates)
        return newDates
    }, [dates?.departureDate, setDates, timeOffset])

    return {
        handleDepartureDateChange,
        handleArrivalDateChange
    }

}
